import React, { useContext, useEffect } from "react";
import { Flex, Input, Text, Heading, TextArea } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../../contexts/i18nContext";
import "./behaviours-tab.scss";

function BehavioursTab(props) {
  const { app, setApp } = props;
  const i18n = useContext(I18nContext);
  const handleInput = (event, field) => {
    const newEditingNode = { ...app };
    if (newEditingNode.appTile[field]) {
      newEditingNode.appTile[field] = event.target.value;
    } else if (newEditingNode.appTile && Object.keys(newEditingNode.appTile) && Object.keys(newEditingNode.appTile).length) {
      newEditingNode.appTile[field] = event.target.value;
    } else {
      newEditingNode.appTile = {};
      newEditingNode.appTile[field] = event.target.value;
    }
    setApp(newEditingNode);
  };

  const handleCustomInput = (event, field, field2, isBoolean) => {
    const newEditingNode = { ...app };
    if (newEditingNode[field] && newEditingNode[field][field2] !== undefined && newEditingNode[field][field2] !== null) {
      newEditingNode[field][field2] = isBoolean ? JSON.parse(event.target.value) : event.target.value;
    } else if (newEditingNode[field] && Object.keys(newEditingNode[field]) && Object.keys(newEditingNode[field]).length) {
      newEditingNode[field][field2] = isBoolean ? JSON.parse(event.target.value) : event.target.value;
    } else {
      newEditingNode[field] = {};
      newEditingNode[field][field2] = isBoolean ? JSON.parse(event.target.value) : event.target.value;
    }
    setApp(newEditingNode);
  };

  useEffect(() => {
    console.log("BehavioursTab Mount");
    return () => {
      console.log("BehavioursTab Destroy");
    };
  }, []);

  return (
    <div className="pBottom40">
      <div>
        <Flex direction="vertical" gap={16}>
          <Flex direction="vertical" gap={8}>
            <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.app-behaviors-text")}</Heading>
            <Heading size="section" style={{ marginTop: 10 }}>
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.new-customer-onboarding-text")}
            </Heading>
            <Text size="p4" weight="regular">
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.support-automated-sign-up-text")}
            </Text>
          </Flex>
          <Flex className="formMaxWidth" direction="vertical" gap={8}>
            <Input
              size="md"
              onChange={(e) => {
                handleCustomInput(e, "developerInfo", "signupUrl", false);
              }}
              value={app.developerInfo?.signupUrl}
              label={i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.sign-up-url-text")}
              placeholder={i18n.t("partner-dashboard-app.placeholders.enter-sign-up-url")}
            />
          </Flex>
          <Flex className="formMaxWidth" direction="vertical" gap={8}>
            <TextArea
              size="md"
              onChange={(e) => {
                handleCustomInput(e, "developerInfo", "contactCompanyInfo", false);
              }}
              value={app.developerInfo?.contactCompanyInfo}
              label={i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.contact-company-info-text")}
              placeholder={i18n.t("partner-dashboard-app.placeholders.company-information-comes-here")}
            />
          </Flex>
          <Flex direction="vertical" gap={8}>
            <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.app-removal-text")}</Heading>
            <Text size="p4" weight="regular">
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.prompts-removal-app-text")}
            </Text>
          </Flex>
          <Flex className="formMaxWidth" direction="vertical" gap={8}>
            <TextArea
              size="md"
              onChange={(e) => {
                handleCustomInput(e, "developerInfo", "deleteAppMessage", false);
              }}
              value={app.developerInfo?.deleteAppMessage}
              label={i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.delete-app-confirmation-text")}
              placeholder={i18n.t("partner-dashboard-app.placeholders.app-delete-confirmation-msg")}
            />
          </Flex>
          <Flex direction="vertical" gap={8}>
            <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.app-monitoring-text")}</Heading>
            <Text size="p4" weight="regular">
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.monitor-app-uptime-text")}
            </Text>
          </Flex>
          <Flex className="formMaxWidth2" direction="vertical" gap={4}>
            <Flex className="formMaxWidth" direction="vertical">
              <Input
                size="md"
                onChange={(e) => {
                  handleInput(e, "healthCheckUrl");
                }}
                value={app.appTile?.healthCheckUrl}
                label={i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.app-health-check-url-text")}
                placeholder={i18n.t("partner-dashboard-app.placeholders.app-health-check-url")}
              />
            </Flex>
            <Text size="p3" weight="regular" className="inputNameLabel">
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.used-to-monitor-app-health-text")}
            </Text>
            <Text size="p4" weight="regular" className="inputNameLabel">
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.ensure-url-starts-with-text")}
              <strong>{i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.https-text")}</strong>
            </Text>
          </Flex>
          <Flex className="formMaxWidth2" direction="vertical" gap={8} style={{ marginTop: 10 }}>
            <Flex className="formMaxWidth" direction="vertical" gap={4}>
              <Input
                size="md"
                onChange={(e) => {
                  handleInput(e, "healthStatusUrl");
                }}
                value={app.appTile?.healthStatusUrl}
                label={i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.api-health-status-url-text")}
                placeholder={i18n.t("partner-dashboard-app.placeholders.enter-api-health-status-url")}
              />
            </Flex>
            <Text size="p3" weight="regular" className="inputNameLabel">
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.determine-health-of-customer-data-text")}
            </Text>
            <Text size="p4" weight="regular" className="inputNameLabel">
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.ensure-url-starts-with-text")}
              <strong>{i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.https-text")}</strong>
            </Text>
          </Flex>
          <Flex className="formMaxWidth2" direction="vertical" gap={8} style={{ marginTop: 10 }}>
            <Flex className="formMaxWidth" direction="vertical" gap={4}>
              <Input
                size="md"
                onChange={(e) => {
                  handleInput(e, "appStatusUrl");
                }}
                value={app.appTile?.appStatusUrl}
                label={i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.app-status-page-url-text")}
                placeholder={i18n.t("partner-dashboard-app.placeholders.enter-app-status-page-url")}
              />
            </Flex>
            <Text size="p3" weight="regular" className="inputNameLabel">
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.tell-up-or-down-text")}
            </Text>
            <Text size="p4" weight="regular" className="inputNameLabel">
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.ensure-url-starts-with-text")}
              <strong>{i18n.t("partner-dashboard-app.partner-apps.partner-app-onboarding.https-text")}</strong>
            </Text>
          </Flex>
        </Flex>
      </div>
    </div>
  );
}

export default BehavioursTab;
